import {load} from '@shopify/theme-sections';
import 'nodelist-foreach-polyfill';

import '../../assets/styles/theme.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import SideCart from './components/SideCart';
import accordions from './components/accordions';
import './components/web-vitals';
import fadeInPage from './components/fader';
import objectFitImages from 'object-fit-images';
import SmoothScroll from 'smooth-scroll';
import tabs from './components/tabs';
import initShogunSlider from './components/shogun-slider';
import initAccountNav from './components/account-nav';
import captureUtmParams from './utils/capture-utm-params';
import initSubscriberTracking from './utils/subscriber-tracking';
import './components/tickerTimer';
import popupInit from './components/popup';
import sendAhintInit from './components/drop-a-hint';
import initSavingCalculator from './components/saving-calculator';
import ModalUpsell from './components/ModalUpsell';
import accountPopup from './components/accountPopup';

import './sections/header';
import './sections/hero-slider';
import './sections/featured-articles';
import './sections/featured-payment-methods';
import './sections/featured-product';
import './sections/featured-products';
import './sections/featured-collection';
import './sections/featured-media';
import './sections/featured-video';
import './sections/page-manuals';
import './sections/carousel-media';
import './sections/grid-blocks';
import './sections/contact-form';
import './sections/stores-map';
import './sections/product-blocks';
import './sections/testimonials-cf';
import './sections/sub-collection-slider';

const ecommerceEnable = window.theme.ecommerce || false;

document.addEventListener('DOMContentLoaded', function() {
  captureUtmParams();

  load('*');

  initSavingCalculator();

  objectFitImages();

  accordions();

  popupInit();
  sendAhintInit();

  if (document.querySelector('.tablist')) {
    tabs();
  }

  fadeInPage();

  initShogunSlider();

  new SmoothScroll('a[href*="#"]', {
    header: '#shopify-section-header',
  });

  if (document.querySelector('.account-nav__toggle')) {
    initAccountNav();
  }

  initSubscriberTracking();
  accountPopup();
});

if (ecommerceEnable) {
  ReactDOM.render(<SideCart />, document.getElementById('side-cart-app'));
}

const modalUpsellEl = document.querySelector('[data-modal-upsell]');
if (modalUpsellEl) {
  ReactDOM.render(<ModalUpsell />, modalUpsellEl)
}
